export const PUBLIC_STATES = [
    {
        name: 'public-landing',
        parent: 'root',
        abstract: true,
        template: require('./public-landing.component.html'),
    },
    {
        name: 'landing.**',
        parent: 'public-landing',
        url: '/',
        lazyLoad: $transitions => {

            const $ocLazyLoad = $transitions.injector().get('$ocLazyLoad');

            return import('../landing-page/landing.module')
                .then(mod => $ocLazyLoad.load(mod.LANDING_PAGE_MODULE))
                .catch(err => {

                    throw new Error(err);
                });
        }
    },
    {
        name: 'request-demo.**',
        parent: 'public-landing',
        url: '/request-demo',
        lazyLoad: $transitions => {

            const $ocLazyLoad = $transitions.injector().get('$ocLazyLoad');

            return import('../our-team/our-team.module')
                .then(mod => $ocLazyLoad.load(mod.OUR_TEAM_MODULE))
                .catch(err => {

                    throw new Error(err);
                });
        }
    },
    {
        name: 'contact-us.**',
        parent: 'public-landing',
        url: '/contact-us',
        lazyLoad: $transitions => {

            const $ocLazyLoad = $transitions.injector().get('$ocLazyLoad');

            return import('../contact-us/contact-us.module')
                .then(mod => $ocLazyLoad.load(mod.CONTACT_US_MODULE))
                .catch(err => {

                    throw new Error(err);
                });
        }
    }
];



// WEBPACK FOOTER //
// ./src/app-modules/public-landing/public.states.js